export const settingContactInfoFormValidate = (formContactValue) => {

    const errors = {}

    if (!formContactValue?.addressCompany?.trim()) {
        errors.addressCompany = "لطفا addressCompany را وارد کنید"
    } else {
        delete errors.addressCompany
    }

    if (!formContactValue?.phone?.trim()) {
        errors.phone = "لطفا phone را وارد کنید"
    } else {
        delete errors.phone
    }

    if (!formContactValue?.mobile?.trim()) {
        errors.mobile = "لطفا mobile را وارد کنید"
    } else {
        delete errors.mobile
    }

    if (!formContactValue?.instagramUrl?.trim()) {
        errors.instagramUrl = "لطفا instagramUrl را وارد کنید"
    } else {
        delete errors.instagramUrl
    }

    if (!formContactValue?.telegramUrl?.trim()) {
        errors.telegramUrl = "لطفا telegramUrl را وارد کنید"
    } else {
        delete errors.telegramUrl
    }

    if (!formContactValue?.whatsappUrl?.trim()) {
        errors.whatsappUrl = "لطفا whatsappUrl را وارد کنید"
    } else {
        delete errors.whatsappUrl
    }

    if (!formContactValue?.email?.trim()) {
        errors.email = "لطفا email را وارد کنید"
    } else {
        delete errors.email
    }

    if (!formContactValue?.footerText?.trim()) {
        errors.footerText = "لطفا footerText را وارد کنید"
    } else {
        delete errors.footerText
    }

    if (!formContactValue?.seoTitle?.trim()) {
        errors.seoTitle = "لطفا seoTitle را وارد کنید"
    } else {
        delete errors.seoTitle
    }

    if (!formContactValue?.seoDescription?.trim()) {
        errors.seoDescription = "لطفا seoDescription را وارد کنید"
    } else {
        delete errors.seoDescription
    }

    if (!formContactValue?.seoKeywords?.trim()) {
        errors.seoKeywords = "لطفا seoKeywords را وارد کنید"
    } else {
        delete errors.seoKeywords
    }

    if (!formContactValue?.seoCanonical?.trim()) {
        errors.seoCanonical = "لطفا seoCanonical را وارد کنید"
    } else {
        delete errors.seoCanonical
    }

    if (!formContactValue?.seoSchema?.trim()) {
        errors.seoSchema = "لطفا seoSchema را وارد کنید"
    } else {
        delete errors.seoSchema
    }

    return errors;

}